import {ProductRender} from './ProductRender';

export class Clock extends ProductRender {

    constructor(options) {
        super(options)

        this.backgroundImage = null
        this.hands = null
        this.handsColor = '#000'
        this.face = null
        this.faceColor = '#000'
    }

    // Background
    setBackground = (imgUrl) => {
        fabric.Image.fromURL(imgUrl, (img) => {
            if (this.backgroundImage !== null) {
                this.canvas.remove(this.backgroundImage)
            }

            img.scaleToWidth(100)
            img.set({
                originX:      'center',
                originY:      'center',
                left:         50,
                top:          50,
                lockSkewingX: true,
                lockSkewingY: true,
                snapAngle:    5
            })

            this.canvas.add(img)
            this.canvas.sendToBack(img)

            this.backgroundImage = img
        })
    }

    deleteBackground = () => {
        this.canvas.remove(this.backgroundImage)
        this.canvas.requestRenderAll()
        this.backgroundImage = null
    }

    // Hand
    setHands = (svgUrl) => {
        this.addSvgObject('hands', svgUrl)
    }

    setHandsColor = (color) => {
        this.handsColor = color
        this.setSvgObjectColor(this.hands, color)
    }

    deleteHands = () => {
        this.canvas.remove(this.hands)
        this.canvas.requestRenderAll()
        this.hands = null
    }

    // Face
    setFace = (svgUrl) => {
        this.addSvgObject('face', svgUrl)
    }

    setFaceColor = (color) => {
        this.faceColor = color
        this.setSvgObjectColor(this.face, color)
    }

    deleteFace = () => {
        this.canvas.remove(this.face)
        this.canvas.requestRenderAll()
        this.face = null
    }

    addSvgObject = (objectName, svgUrl) => {
        fabric.loadSVGFromURL(svgUrl, (objects, options) => {
            if (this[objectName] !== null) {
                this.canvas.remove(this[objectName])
            }

            const svgGroup = new fabric.util.groupSVGElements(objects, options)

            svgGroup.set({
                left:        0,
                top:         0,
                width:       100,
                height:      100,
                evented:     false,
                selectable:  false,
                hasControls: false
            })

            this[objectName] = svgGroup
            this.setSvgObjectColor(this[objectName], this[objectName + 'Color'])

            this.canvas.add(svgGroup)
            this.canvas.bringToFront(svgGroup)

            if (this.hands) {
                this.canvas.bringToFront(this.hands)
            }

            this.canvas.renderAll()
        })
    }

    setSvgObjectColor = (object, color = '#000') => {
        for (let i = 0; i < object._objects.length - 1; i++) {
            if (object.item(i).get('fill') !== 'black') {
                object.item(i).set({
                    fill: color
                })
            }
        }

        this.canvas.renderAll()
    }
}